import * as Phaser from "phaser-ce"
import { PhaserUtils } from "../../utils/PhaserUtils"

export enum CampCravingsAssets {
    BACKGROUND = "CampCravingsBACKGROUND",
    DECK_LOCATIONS = "CampCravingsDECK_LOCATIONS",
    TITLE = "CampCravingsTITLE",
    USER_CARDS_ROUND_1 = "CampCravingsUSER_CARDS_ROUND_1",
    NON_USER_CARDS_ROUND_1 = "CampCravingsNON_USER_CARDS_ROUND_1",
    USER_CARDS_ROUND_2 = "CampCravingsUSER_CARDS_ROUND_2",
    NON_USER_CARDS_ROUND_2 = "CampCravingsNON_USER_CARDS_ROUND_2",
    CARD_HIGHLIGHT = "CampCravingsCARD_HIGHLIGHT",

    PICNIC = "CampCravingsPICNIC",
    USER_VAPING = "CampCravingsUSER_VAPING",
    LAKE = "CampCravingsLAKE",
    LODGE = "CampCravingsLODGE",
    BUS = "CampCravingsBUS",
    STATIONARY_USER_PAWN = "CampCravingsSTATIONARY_USER_PAWN",
    STATIONARY_NON_USER_PAWN = "CampCravingsSTATIONARY_NON_USER_PAWN",

    NON_USER_PAWN_ROUND_1 = "CampCravingsNON_USER_PAWN_ROUND_1",
    USER_PAWN_ROUND_1 = "CampCravingsUSER_PAWN_ROUND_1",
    NON_USER_PAWN_ROUND_2 = "CampCravingsNON_USER_PAWN_ROUND_2",
    USER_PAWN_ROUND_2 = "CampCravingsUSER_PAWN_ROUND_2",

    // Audio
    INTRO = "CampCravingsINTRO",
    ROUND_1_PLAYER_1_BUS = "CampCravingsROUND_1_PLAYER_1_BUS",
    ROUND_1_PLAYER_2_BUS = "CampCravingsROUND_1_PLAYER_2_BUS",
    ROUND_1_PLAYER_1_LAKE = "CampCravingsROUND_1_PLAYER_1_LAKE",
    ROUND_1_PLAYER_2_LAKE = "CampCravingsROUND_1_PLAYER_2_LAKE",
    ROUND_1_PLAYER_1_NATURE_TRAIL = "CampCravingsROUND_1_PLAYER_1_NATURE_TRAIL",
    ROUND_1_PLAYER_2_NATURE_TRAIL = "CampCravingsROUND_1_PLAYER_2_NATURE_TRAIL",
    ROUND_1_PLAYER_1_HORSES = "CampCravingsROUND_1_PLAYER_1_HORSES",
    ROUND_1_PLAYER_2_HORSES = "CampCravingsROUND_1_PLAYER_2_HORSES",
    ROUND_1_PLAYER_1_FINISH = "CampCravingsROUND_1_PLAYER_1_FINISH",
    ROUND_1_SUMMARY = "CampCravingsROUND_1_SUMMARY",

    ROUND_2_INTRO = "CampCravingsROUND_2_INTRO",
    ROUND_2_PLAYER_1_LAKE = "CampCravingsROUND_2_PLAYER_1_LAKE",
    ROUND_2_PLAYER_2_LAKE = "CampCravingsROUND_2_PLAYER_2_LAKE",
    ROUND_2_PLAYER_1_PICNIC = "CampCravingsROUND_2_PLAYER_1_PICNIC",
    ROUND_2_PLAYER_2_PICNIC = "CampCravingsROUND_2_PLAYER_2_PICNIC",
    ROUND_2_PLAYER_1_HORSES = "CampCravingsROUND_2_PLAYER_1_HORSES",
    ROUND_2_PLAYER_2_HORSES = "CampCravingsROUND_2_PLAYER_2_HORSES",
    ROUND_2_PLAYER_1_LODGE = "CampCravingsROUND_2_PLAYER_1_LODGE",
    ROUND_2_PLAYER_2_LODGE = "CampCravingsROUND_2_PLAYER_2_LODGE",
    ROUND_2_PLAYER_1_FINISH = "CampCravingsROUND_2_PLAYER_1_FINISH",
    ROUND_2_SUMMARY = "CampCravingsROUND_2_SUMMARY",

    // Sounds
    BIRD_SCREECH = "CampCravingsBIRD_SCREECH",
    HORSE_SLOW = "CampCravingsHORSE_SLOW",
    HORSE_FAST = "CampCravingsHORSE_FAST",
    CARD_TURNING = "CampCravingsCARD_TURNING",
    CHILDREN_TALKING = "CampCravingsCHILDREN_TALKING",
    FISHING_REEL = "CampCravingsFISHING_REEL",
    LODGE_PARTY_MUSIC = "CampCravingsLODGE_PARTY_MUSIC",
    YOUR_TURN = "CampCravingsYOUR_TURN",

    // Testimonial Outro Assets
    OUTRO1 = "CampCravingsOUTRO1",

    BUDDY_TESTIMONIALS_INTRO = "CampCravingsBUDDY_TESTIMONIALS_INTRO",

    TESTIMONIAL_1 = "CampCravingsTESTIMONIAL_1",
    TESTIMONIAL_2 = "CampCravingsTESTIMONIAL_2",

    TESTIMONIAL_1_IMAGE = "CampCravingsTESTIMONIAL_1_IMAGE",
    TESTIMONIAL_2_IMAGE = "CampCravingsTESTIMONIAL_2_IMAGE",
}

export function loadAssets(game: Phaser.Game) {

    const load = PhaserUtils.makeLoader(game, "camp-cravings")

    load.image(CampCravingsAssets.BACKGROUND, "background.png")
    load.image(CampCravingsAssets.DECK_LOCATIONS, "deck-locations.png")
    load.image(CampCravingsAssets.TITLE, "title.png")
    load.image(CampCravingsAssets.BUS, "bus.png")
    load.image(CampCravingsAssets.STATIONARY_NON_USER_PAWN, "non-user-pawn.png")
    load.image(CampCravingsAssets.STATIONARY_USER_PAWN, "user-pawn.png")
    load.image(CampCravingsAssets.CARD_HIGHLIGHT, "card-highlight.png")

    load.spritesheet(CampCravingsAssets.LAKE, "lake.png", 163, 248)
    load.spritesheet(CampCravingsAssets.LODGE, "lodge-party.png", 136, 91)

    load.atlas(CampCravingsAssets.NON_USER_PAWN_ROUND_1, "non-user-pawn-round1.json")
    load.atlas(CampCravingsAssets.USER_PAWN_ROUND_1, "user-pawn-round1.json")
    load.atlas(CampCravingsAssets.NON_USER_PAWN_ROUND_2, "non-user-pawn-round2.json")
    load.atlas(CampCravingsAssets.USER_PAWN_ROUND_2, "user-pawn-round2.json")
    load.atlas(CampCravingsAssets.USER_CARDS_ROUND_1, "user-cards-round1.json")
    load.atlas(CampCravingsAssets.NON_USER_CARDS_ROUND_1, "non-user-cards-round1.json")
    load.atlas(CampCravingsAssets.USER_CARDS_ROUND_2, "user-cards-round2.json")
    load.atlas(CampCravingsAssets.NON_USER_CARDS_ROUND_2, "non-user-cards-round2.json")
    load.atlas(CampCravingsAssets.PICNIC, "picnic.json")
    load.atlas(CampCravingsAssets.USER_VAPING, "user-vaping.json")

    load.audio(CampCravingsAssets.INTRO, "camp-cravings-n-intro.mp3")
    load.audio(CampCravingsAssets.ROUND_1_PLAYER_1_BUS, "camp-cravings-n1.mp3")
    load.audio(CampCravingsAssets.ROUND_1_PLAYER_2_BUS, "camp-cravings-n2.mp3")
    load.audio(CampCravingsAssets.ROUND_1_PLAYER_1_LAKE, "camp-cravings-n3.mp3")
    load.audio(CampCravingsAssets.ROUND_1_PLAYER_2_LAKE, "camp-cravings-n4.mp3")
    load.audio(CampCravingsAssets.ROUND_1_PLAYER_1_NATURE_TRAIL, "camp-cravings-n5.mp3")
    load.audio(CampCravingsAssets.ROUND_1_PLAYER_2_NATURE_TRAIL, "camp-cravings-n6.mp3")
    load.audio(CampCravingsAssets.ROUND_1_PLAYER_1_HORSES, "camp-cravings-n7.mp3")
    load.audio(CampCravingsAssets.ROUND_1_PLAYER_2_HORSES, "camp-cravings-n8.mp3")
    load.audio(CampCravingsAssets.ROUND_1_PLAYER_1_FINISH, "camp-cravings-n9.mp3")
    load.audio(CampCravingsAssets.ROUND_1_SUMMARY, "camp-cravings-n10.mp3")

    load.audio(CampCravingsAssets.ROUND_2_INTRO, "camp-cravings-n11.mp3")
    load.audio(CampCravingsAssets.ROUND_2_PLAYER_1_LAKE, "camp-cravings-n12.mp3")
    load.audio(CampCravingsAssets.ROUND_2_PLAYER_2_LAKE, "camp-cravings-n13.mp3")
    load.audio(CampCravingsAssets.ROUND_2_PLAYER_1_PICNIC, "camp-cravings-n14.mp3")
    load.audio(CampCravingsAssets.ROUND_2_PLAYER_2_PICNIC, "camp-cravings-n15.mp3")
    load.audio(CampCravingsAssets.ROUND_2_PLAYER_1_HORSES, "camp-cravings-n16.mp3")
    load.audio(CampCravingsAssets.ROUND_2_PLAYER_2_HORSES, "camp-cravings-n17.mp3")
    load.audio(CampCravingsAssets.ROUND_2_PLAYER_1_LODGE, "camp-cravings-n18.mp3")
    load.audio(CampCravingsAssets.ROUND_2_PLAYER_2_LODGE, "camp-cravings-n19.mp3")
    load.audio(CampCravingsAssets.ROUND_2_PLAYER_1_FINISH, "camp-cravings-n20.mp3")
    load.audio(CampCravingsAssets.ROUND_2_SUMMARY, "camp-cravings-n-outro.mp3")

    load.audio(CampCravingsAssets.BIRD_SCREECH, "bird-screech.mp3")
    load.audio(CampCravingsAssets.CARD_TURNING, "card-turning.wav")
    load.audio(CampCravingsAssets.CHILDREN_TALKING, "children-lunch1.mp3")
    load.audio(CampCravingsAssets.FISHING_REEL, "fishing-reel.mp3")
    load.audio(CampCravingsAssets.HORSE_FAST, "horse-fast-walk.mp3")
    load.audio(CampCravingsAssets.HORSE_SLOW, "horse-slow.mp3")
    load.audio(CampCravingsAssets.LODGE_PARTY_MUSIC, "lodge-party-music.mp3")
    load.audio(CampCravingsAssets.YOUR_TURN, "your-turn.mp3")
}
